import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration
import Filter from 'jet-views/customers/reports/playerPrizesLoyalty/filterPlayerPrizesLoyalty'; // Importing Filter component
import Table from 'jet-views/customers/reports/playerPrizesLoyalty/tablePlayerPrizesLoyalty'; // Importing Table component

/**
 * PlayerPrizesLoyaltyView class extends JetView to create a report view for PrizesLoyalty.
 */
export default class PlayerPrizesLoyaltyView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        if (!devConfig.getPermAction('customersReportsPlayerPrizesLoyaltyReportMenu', 'Menu')) {
            webix.message({
                type: "error",
                text: "No tienes permiso para acceder a este módulo"
            });
            const url = window.location.href;
            const match = url.match(/(\?user=\d+)/);
            if (match) {
                const newPath = "/top/customers" + match[0] + "/customers.reportscustomer";
                this.app.show(newPath);
            }
            return;
        }
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const toolbar = {
            view: 'toolbar', // Toolbar component
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Columns within the toolbar
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'], // Options for page size
                    width: 70, // Width of the dropdown
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh the datatable
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager display
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export', // Name of the export dropdown
                    id: 'Export', // Unique identifier for the export dropdown
                    width: 120, // Width of the dropdown
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        // Export options
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index on the current page
                            var last = first + size - 1; // Last item index on the current page
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the datatable
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter function for export
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones', // Filename for the export
                                    ignore: {
                                        detailTittle: true, // Ignore detail title in export
                                        ActionTittle: true, // Ignore action title in export
                                    },
                                    footer: false, // Do not include footer in export
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter function for export
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones', // Filename for the export
                                        autowidth: true, // Enable auto width for PDF
                                        ignore: {
                                            detailTittle: true, // Ignore detail title in export
                                            ActionTittle: true, // Ignore action title in export
                                        },
                                        footer: false, // Do not include footer in export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            height: screen.width < 500 ? 0 : 600, // Conditional height based on screen width
            rows: [
                // Rows in the left section
                {
                    view: 'toolbar', // Toolbar for search
                    css: theme, // Apply current theme
                    id: 'toolbar-search', // Unique identifier for the search toolbar
                    elements: [
                        { view: 'label', label: _('Reporte de Sesiones') }, // Label for the report title
                        {
                            type: 'wide', // Wide button type
                            css: 'close-bottom', // CSS class for styling
                            id: 'button-search', // Unique identifier for the search button
                            cols: [
                                {
                                    view: 'icon', // Icon for the search button
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Width of the icon
                                    height: 30, // Height of the icon
                                    click: () => {
                                        // Click event for the icon
                                        $$('filterPopup').show(); // Show filter popup
                                    },
                                },
                            ],
                        },
                    ],
                },
                Filter, // Include Filter component
                Table, // Include Table component
                toolbar, // Include toolbar
            ],
        };
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean', // Clean type for the form
            view: 'form', // Form view
            scrollY: true, // Enable vertical scrolling
            css: 'scrolling', // CSS class for styling
            rows: [
                // Rows in the main layout
                {
                    responsive: 'a5', // Responsive layout identifier
                    type: 'wide', // Wide type for the column
                    cols: [left], // Include left section
                },
            ],
        };
    }

    /**
     * Initializes the sessions report view.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Ensure Webix is ready
            if (screen.width < 500 || screen.height < 500) {
                // Check for small screens
                var childs = $$('toolbar').getChildViews(); // Get child views of the toolbar
                $$('toolbar').removeView(childs[2]); // Remove the third child view
                $$('pagerA').define('group', 1); // Define pager grouping
            }
            if (screen.width > 500 && screen.height > 500) {
                // Check for larger screens
                $$('toolbar-search').hide(); // Hide the search toolbar
            }
            $.fn.scrollBottom = function () {
                // jQuery function to calculate scroll bottom
                return $(document).height() - this.scrollTop() - this.height(); // Return scroll bottom value
            };
        });
    }
}

// FILE DOCUMENTED

